<template>
  <v-dialog v-model="dialog" max-width="290" @keydown.esc="cancel" persistent>
    <v-card justify-center>
      <v-card-text class="text-md-center">{{ title }}</v-card-text>
      <v-card-actions justify-center>
        <v-spacer />
        <v-btn color="red" flat @click.native="cancel">Cancel</v-btn>
        <v-btn color="green darken-1" flat @click.native="agree">{{ sbmtText }}</v-btn> <!--deleteElement(props.item.id)-->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      resolve: null,
      reject: null,
      title: null,
      sbmtText: 'Submit',
      options: {
        color: 'primary'
      }
    }),
    methods: {
      open (title, sbmtText, options) {
        this.dialog = true
        this.title = title
        this.sbmtText = sbmtText
        this.options = Object.assign(this.options, options)
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      agree () {
        this.resolve(true)
        this.dialog = false
      },
      cancel () {
        this.reject()
        this.dialog = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ConfirmationDialog.vue?05feeee4